var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeInvisibleMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_898_19479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.49428 4.24782C5.71611 3.50348 7.13189 2.95044 8.64299 2.95044C12.0768 2.95044 15.0184 5.80624 16.3107 7.27309C16.5148 7.51162 16.6278 7.8215 16.6278 8.14282C16.6278 8.46413 16.5148 8.77402 16.3107 9.01254C15.5984 9.8211 14.3848 11.0517 12.8641 11.9934M10.4891 13.0693C9.89545 13.2377 9.27763 13.3352 8.64299 13.3352C5.20915 13.3352 2.26761 10.4794 0.975297 9.01254C0.771187 8.77402 0.658203 8.46413 0.658203 8.14282C0.658203 7.8215 0.771187 7.51162 0.975297 7.27309C1.38474 6.80835 1.95973 6.20418 2.66348 5.5956",
    stroke: "#202124",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3835 9.77468C11.3448 8.87347 11.3448 7.41232 10.3835 6.51111C9.42218 5.60991 7.86364 5.60991 6.90234 6.51111",
    stroke: "#202124",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6426 15.6428L0.642578 0.642822",
    stroke: "#202124",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_898_19479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeInvisibleMenu);
export default __webpack_public_path__ + "static/media/eye-invisible-menu.d2587f6910ad561ca30fa29222c0e9e5.svg";
export { ForwardRef as ReactComponent };